/** Matches {@code AccountUserInfoEntity.adminUser} / {@code AdminUserRoleEnum} in Osync-AWS. */
export const ADMIN_TOOL_ACCOUNT_USER_ROLE = Object.freeze({
  USER: 0,
  ADMIN_USER: 1,
  ADMIN: 11,
  SUPER_ADMIN: 21,
});

export const adminToolCanUseGdprAccountDeletion = (adminUserRole) =>
  adminUserRole === ADMIN_TOOL_ACCOUNT_USER_ROLE.ADMIN ||
  adminUserRole === ADMIN_TOOL_ACCOUNT_USER_ROLE.SUPER_ADMIN;

const origin = window.location.origin;
let url;
if (origin) {
  if (origin.startsWith("http://localhost")) {
    url = "http://localhost:7000/adminapi/v2/";
  } else if (origin.indexOf("rekzyl.com") !== -1) {
    url = origin.replace("client", "server") + "/adminapi/v2/";
  } else if (origin.indexOf("pre-omessage.oapps.xyz") !== -1) {
    url = "https://pre-api.oapps.xyz/rest/adminapi/v2/";
  } else {
    url = "https://api.oapps.xyz/rest/adminapi/v2/";
  }
}
export let ADMIN_SERVER_API = url;
